import {SxProps, Theme} from '@mui/material';
import theme from '../../theme';

export const wrapperSx: SxProps<Theme> = {
    pt: 5,
    [theme.breakpoints.down('lg')]: {
        pt: 1,
    },
};
